import React from 'react';
import { useTranslation } from 'react-i18next';
import InputFilterItem from '../../../../components/InputFilterItem';
import SingleSelect from '../../../../components/SingleSelect';
import { getSmartLabelClassName } from '../../../../utils/labelWidthUtils';

export interface FilterOptions {
  keywordFrom?: string;
  keywordTo?: string;
  status?: string;
  state?: string;
  city?: string;
  zipCode?: string;
}

export const DEFAULT_FILTER_OPTIONS: FilterOptions = {
  keywordFrom: undefined,
  keywordTo: undefined,
  status: undefined,
  state: undefined,
  city: undefined,
  zipCode: undefined,
};

interface FilterAreaProps {
  filters: FilterOptions;
  setFilters: (filters: FilterOptions) => void;
}

const FilterArea: React.FC<FilterAreaProps> = ({ filters, setFilters }) => {
  const { t } = useTranslation();

  const handleChange = (key: keyof FilterOptions, value: string | undefined) => {
    const processed = typeof value === 'string' && value.trim() === '' ? undefined : value;
    setFilters({ ...filters, [key]: processed });
  };

  const columnLabels = [
    t('mapTool.addressKeywordRule.filters.keywordFrom'),
    t('mapTool.addressKeywordRule.filters.keywordTo'),
    t('mapTool.addressKeywordRule.filters.status'),
    t('mapTool.addressKeywordRule.filters.state'),
    t('mapTool.addressKeywordRule.filters.city'),
    t('mapTool.addressKeywordRule.filters.zipCode'),
  ];
  const labelClassName = getSmartLabelClassName(columnLabels);

  const statusOptions = [
    { label: t('mapTool.addressKeywordRule.status.enabled'), value: '1' },
    { label: t('mapTool.addressKeywordRule.status.disabled'), value: '0' },
  ];

  return (
    <div className="mb-2 pl-0 py-2">
      <div className="grid grid-cols-3 gap-x-10 gap-y-4 items-start">
        <div className="min-w-0">
          <InputFilterItem
            label={t('mapTool.addressKeywordRule.filters.keywordFrom')}
            value={filters.keywordFrom ?? ''}
            onChange={(e) => handleChange('keywordFrom', e.target.value)}
            spanClassName={labelClassName}
            placeholder={t('mapTool.addressKeywordRule.placeholders.fuzzy') as string}
          />
        </div>
        <div className="min-w-0">
          <InputFilterItem
            label={t('mapTool.addressKeywordRule.filters.keywordTo')}
            value={filters.keywordTo ?? ''}
            onChange={(e) => handleChange('keywordTo', e.target.value)}
            spanClassName={labelClassName}
            placeholder={t('mapTool.addressKeywordRule.placeholders.fuzzy') as string}
          />
        </div>
        <div className="min-w-0">
          <SingleSelect
            label={t('mapTool.addressKeywordRule.filters.status')}
            options={statusOptions}
            value={filters.status}
            onChange={(v) => handleChange('status', v)}
            spanClassName={labelClassName}
            allowClear
          />
        </div>
        <div className="min-w-0">
          <InputFilterItem
            label={t('mapTool.addressKeywordRule.filters.state')}
            value={filters.state ?? ''}
            onChange={(e) => handleChange('state', e.target.value)}
            spanClassName={labelClassName}
          />
        </div>
        <div className="min-w-0">
          <InputFilterItem
            label={t('mapTool.addressKeywordRule.filters.city')}
            value={filters.city ?? ''}
            onChange={(e) => handleChange('city', e.target.value)}
            spanClassName={labelClassName}
          />
        </div>
        <div className="min-w-0">
          <InputFilterItem
            label={t('mapTool.addressKeywordRule.filters.zipCode')}
            value={filters.zipCode ?? ''}
            onChange={(e) => handleChange('zipCode', e.target.value)}
            spanClassName={labelClassName}
          />
        </div>
      </div>
    </div>
  );
};

export default FilterArea;
